import React from 'react'
import { NavLink } from 'react-router-dom'
import './index.scss'

const SubNav = (props) => {
    const selected = props.selected;
    return (
        <div className="SubNav">
            <div className="sub-box">
                <NavLink className="nav-opt" activeClassName="active" isActive={() => (selected === 'home')} to="/">首页</NavLink>
                <NavLink className="nav-opt" activeClassName="active" isActive={() => (selected === 'edu')} to="/edu">出借人教育</NavLink>
                <NavLink className="nav-opt" activeClassName="active" isActive={() => (selected === 'infodcs')} to="/infodcs">信息披露</NavLink>
            </div>
        </div>
    )
}

export default SubNav;


// WEBPACK FOOTER //
// ./src/components/SubNav/index.js